import { Abacus } from "core/Abacus.Core";
import { Class } from "core/Abacus.Utilities";
	
let TableFixOptions = {
	fullwidthtable: 'full',
	storytable: 'story'
}

class TableFix extends Class {
	constructor(table){
		super();
		this.table = $(table);
		this.setOptions(TableFixOptions, this.table.parseClass());
		
		var maxWidth = this.table.parent().width();
		var floatWidth = parseInt(maxWidth * 0.6);
		var width = this.table.width();
		
		if (width >= maxWidth){
			this.table.wrap('<div class="table-' + this.options.fullwidthtable + '"></div>');
		} else {
			this.table.wrap('<div class="table-' + this.options.storytable + '"></div>');
		}

	}
}

export { TableFix };


// WEBPACK FOOTER //
// ./Javascript/core/classes/tablefix.class.js